import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { RegisterRequest, RegisterResponse, ApiService, ValidationResponse, ApiResponse } from "../../services/ApiService";
import AuthValidation from "../../models/validation/AuthValidation";
import { CookieService } from './../../services/CookieService';
import { Router } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterPageComponent implements OnInit {

  model: RegisterRequest;
  confirm_password: string = "";
  show_error: boolean = false;
  error_text: string = "";
  is_loading: boolean = false;

  constructor(private ref: ChangeDetectorRef, private router: Router, private apiService: ApiService, private cookieService: CookieService) { }

  ngOnInit(): void {
    this.cookieService.Redirect(this.router, "register");
    this.model = new RegisterRequest("", "", "", "");
  }

  /**
   * Called when the 'Create Account' button is pressed.
   */
  createAccountPressed(): void {
    let modelValid: ValidationResponse = this.model.isValid();
    if (!modelValid.isSuccess) {
      this.show_error = true;
      this.error_text = modelValid.error;
      return;
    }

    // Confirm password field is not part of the request model, so we need an additional validation check:
    let confirmPasswordCheck: ValidationResponse = AuthValidation.PasswordValid(this.confirm_password, "Confirm Password");
    if (!confirmPasswordCheck.isSuccess) {
      this.show_error = true;
      this.error_text = confirmPasswordCheck.error;
      return;
    }
    if (this.confirm_password != this.model.password) {
      this.show_error = true;
      this.error_text = "Password and Confirm Password do not match!";
      return;
    }

    // Send the register request
    this.show_error = false;
    this.is_loading = true;
    this.apiService.authToken = "";
    this.apiService.SendRequest<RegisterResponse>(this.model,
      (response: ApiResponse<RegisterResponse>) => {
        if (response.isSuccess) {
          this.cookieService.SetValue("Email", this.model.email);
          this.cookieService.SetValue("Username", this.model.username);
          this.cookieService.SetValue("EmailVerified", "false");
          this.cookieService.SetValue("AuthToken", response.values.token);
          this.router.navigate(["/email-verif"]);
          this.ref.detectChanges();
          return true;
        } else {
          this.show_error = true;
          this.error_text = response.getPrimaryErrorMessage();
        }
        this.is_loading = false;
        this.ref.detectChanges();
        return false;
      }
    );
  }
}
